
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/partners",
      function () {
        return require("private-next-pages/training/partners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/partners"])
      });
    }
  